import RenderToast from "../RenderToast";

const CopyableText = ({
  text = null,
  message = "Text copied successfully",
  enableTitle = true,
  children,
}) => {
  if (!text) return "-";

  return (
    <span
      {...(enableTitle ? { title: text } : {})}
      style={{ cursor: "pointer" }}
      onClick={() => {
        navigator.clipboard.writeText(text);
        RenderToast({
          type: "success",
          message,
        });
      }}
    >
      {children}
    </span>
  );
};

export default CopyableText;
